import React from 'react';
import { AccountSelectorWithUrlChangePropTypes } from './shapes';

export const WithHashChange = AccountSelector =>
  class extends React.Component {
    constructor(props) {
      super(props);
      this.state = { routeLocation: window.location.href };
    }

    componentDidMount = () => {
      window.addEventListener('hashchange', this.onHashChange);
    }

    componentWillUnmount = () => {
      window.removeEventListener('hashchange', this.onHashChange);
    }

    onHashChange = () => {
      this.setState({ routeLocation: window.location.href });
    }

    render = () => (
      <AccountSelector {...this.props} routeLocation={this.state.routeLocation} />
    );
  };

WithHashChange.propTypes = AccountSelectorWithUrlChangePropTypes;
